import { UHUU_MKTPC_ID, MAX_EXHIBITIONS, SALE_TYPES, UHUU_GENERAL_TICKET_TYPE } from './constants';

export const serializeAccounts = (accounts = []) => {
  return accounts.map(acc => ({
    id: acc.id,
    label: acc.nome,
    value: acc.id,
  }));
};

export const serializeEventSectors = events => {
  let sectorsFormatted = [];
  let repetitions = [];
  events.forEach(ev => {
    ev.exhibitions.forEach(ap => {
      ap.repetitions.forEach(rep => {
        if (rep.checked) {
          repetitions = repetitions.concat(rep.id);
          sectorsFormatted = sectorsFormatted.concat(
            rep.sectors
              .filter(sector => sectorsFormatted.every(sec => sec.id !== sector.id))
              .map(sector => ({
                id: sector.id,
                name: sector.name,
                checked: !!sector.checked,
                disabled: sector.disabled,
              }))
          );
        }
      });
    });
  });
  return {
    sectorsFormatted,
    repetitions,
  };
};

export const serializeSectorBenefits = events => {
  let sectors = [];

  const isSomeBenefitDisabled = (secId, benefitId, exhibition) => {
    return exhibition.repetitions.some(
      rep =>
        rep.checked &&
        rep.sectors.some(
          sector =>
            sector.id === secId &&
            sector.checked &&
            sector.benefits.some(ben => ben.id === benefitId && !!ben.disabled)
        )
    );
  };

  events.forEach(ev => {
    ev.exhibitions.forEach(ap => {
      ap.repetitions.every(rep => {
        if (rep.checked) {
          rep.sectors.forEach(sector => {
            if (sector.checked && sectors.every(sec => sec.id !== sector.id)) {
              sectors.push({
                id: sector.id,
                name: sector.name,
                options: sector.benefits.map(item => ({
                  id: item.id,
                  name: item.name,
                  checked:
                    !(isSomeBenefitDisabled(sector.id, item.id, ap) || item.disabled) &&
                    !!item.checked,
                  disabled: isSomeBenefitDisabled(sector.id, item.id, ap) || item.disabled,
                })),
              });
            }
          });
          return false;
        }
        return true;
      });
    });
  });
  return sectors;
};

export const serializeSelectedEvents = (events, account, saleType) => {
  return events
    .filter(ev => ev.exhibitions.some(ex => ex.repetitions.some(rep => rep.checked)))
    .map(ev => ({
      id: ev.id,
      accountId: account.id,
      accountName: account.label,
      exhibitions:
        saleType === SALE_TYPES.defaultMenu
          ? ev.exhibitions
              .filter(ex => ex.repetitions.some(rep => rep.checked))
              .map(ex => ({
                id: ex.id,
              }))
          : ev.exhibitions
              .filter(ex => ex.repetitions.some(rep => rep.checked))
              .map(ex => ({
                id: ex.id,
                repetitions: ex.repetitions
                  .filter(rep => rep.checked)
                  .map(rep => {
                    return rep.sectors.some(sec => sec.checked)
                      ? {
                          id: rep.id,
                          sectors: rep.sectors
                            .filter(sector => sector.checked)
                            .map(sector => ({
                              id: sector.id,
                              hasFullPriceTicketBenefit: sector.benefits.some(
                                benefit =>
                                  benefit.id === UHUU_GENERAL_TICKET_TYPE && benefit.checked
                              ),
                              benefits: sector.benefits
                                .filter(benefit => benefit.checked && Number.isInteger(benefit.id))
                                .map(benefit => ({
                                  id: benefit.id,
                                })),
                            })),
                        }
                      : {
                          id: rep.id,
                        };
                  }),
              })),
    }));
};

export const serializeUhuuEvents = events => {
  return events.map(ev => ({
    id: ev.id,
    name: ev.nome,
    exhibitions: ev.apresentacoes.map(ap => ({
      id: ap.id,
      local: {
        id: ap.local.id,
        name: ap.local.nome,
      },
      repetitions: ap.repeticoes.map(rep => ({
        id: rep.id,
        exhibitionDate: rep.dataApresentacao,
        sectors: rep.setores.map(sector => ({
          id: sector.id,
          name: sector.nome,
          benefits: [
            {
              id: UHUU_GENERAL_TICKET_TYPE,
              name: 'Inteira',
            },
            ...sector.beneficios.map(benefit => ({
              id: benefit.id,
              name: benefit.nome,
            })),
          ],
        })),
      })),
    })),
  }));
};

const isRepChecked = (events, repId, exhibitionId) =>
  events.some(ev =>
    ev.exhibitions.some(
      ex => ex.id === exhibitionId && ex.repetitions.some(rep => rep.id === repId)
    )
  );

const isSectorChecked = ({ sector, events, repId, exhibitionId }) =>
  events.some(ev =>
    ev.exhibitions.some(
      ex =>
        ex.id === exhibitionId &&
        ex.repetitions.some(
          rep => rep.id === repId && (rep.sectors && rep.sectors.some(sec => sec.id === sector.id))
        )
    )
  );

const isBenefitChecked = ({ benefitId, sectorId, events, repId, exhibitionId }) =>
  events.some(ev =>
    ev.exhibitions.some(
      ex =>
        ex.id === exhibitionId &&
        ex.repetitions.some(
          rep =>
            rep.id === repId &&
            rep.sectors.some(
              sec =>
                sec.id === sectorId &&
                (benefitId === UHUU_GENERAL_TICKET_TYPE
                  ? sec.hasFullPriceTicketBenefit
                  : sec.benefits.some(ben => ben.id === benefitId))
            )
        )
    )
  );

export const checkStoredEvents = (stateEvents, events) => {
  return stateEvents.map(ev => ({
    ...ev,
    exhibitions: ev.exhibitions.map(ex => ({
      ...ex,
      repetitions: ex.repetitions.map(rep => {
        const isChecked = isRepChecked(events, rep.id, ex.id);
        return {
          ...rep,
          checked: isChecked,
          sectors: isChecked
            ? rep.sectors.map(sector => {
                const isSecChecked = isSectorChecked({
                  sector,
                  events,
                  repId: rep.id,
                  exhibitionId: ex.id,
                });
                return {
                  ...sector,
                  checked: isSecChecked,
                  benefits: isSecChecked
                    ? sector.benefits.map(benefit => ({
                        ...benefit,
                        checked: isBenefitChecked({
                          events,
                          benefitId: benefit.id,
                          sectorId: sector.id,
                          exhibitionId: ex.id,
                          repId: rep.id,
                        }),
                      }))
                    : sector.benefits,
                };
              })
            : rep.sectors,
        };
      }),
    })),
  }));
};

export const isUhuuMtkpc = marketplaces => {
  return marketplaces.some(mktpc =>
    typeof mktpc === 'object' ? mktpc.id === UHUU_MKTPC_ID : mktpc === UHUU_MKTPC_ID
  );
};

export const checkMaxExhibitions = (events, exhibitionId) => {
  let canAddExibhitions = true;
  let exhibitionsCount = 0;
  events.forEach(ev => {
    const exhibitions = ev.exhibitions.filter(ex => ex.repetitions.some(rep => rep.checked));
    exhibitionsCount += exhibitions ? exhibitions.length : 0;
  });

  if (exhibitionsCount >= MAX_EXHIBITIONS) {
    const hasChecked = events.some(ev =>
      ev.exhibitions.some(ex => ex.id === exhibitionId && ex.repetitions.some(rep => rep.checked))
    );
    if (!hasChecked) {
      canAddExibhitions = false;
    }
  }

  return canAddExibhitions;
};

export const serializeEvents = events => {
  return events.map(event => ({
    id: event.id,
    name: event.name,
    options: event.exhibitions.map(ex => {
      const isDisabled = !checkMaxExhibitions(events, ex.id); // eslint-disable-line
      return {
        ...ex,
        name: ex.local.name,
        disabled: isDisabled || ex.disabled,
        repetitions: ex.repetitions.map(rep => ({
          ...rep,
          disabled: isDisabled || !!rep.disabled,
        })),
      };
    }),
  }));
};

export const getPossibleEvents = ({ events, menus, accId, saleType, menuId = null }) => {
  const shouldFilterMenuId = !!menuId;
  const uhuuMenus = menus.filter(
    menu =>
      isUhuuMtkpc(menu.marketplaces) &&
      (shouldFilterMenuId ? menu.id !== menuId : true) &&
      saleType === menu.menuUhuuTypeId &&
      menu.uhuuEvents.some(ev => ev.accountId === accId)
  );

  const menuUhuuChecked = menus.filter(menu => menu.id === menuId);
  const menuUhuuCheckedId =
    menuUhuuChecked.length > 0 ? menuUhuuChecked[0].uhuuEvents[0].exhibitions[0].id : null;

  return events.map(ev => ({
    ...ev,
    exhibitions: ev.exhibitions.map(ex => {
      const isAllRepSelected = ex.repetitions.every(rep =>
        saleType === SALE_TYPES.generalMenu
          ? hasSelectedRepetition(rep.id, uhuuMenus, accId)
          : rep.sectors.every(sector => isAllBenefitsChecked(rep.id, sector, uhuuMenus, ex.id))
      );
      return {
        ...ex,
        disabled:
          saleType === SALE_TYPES.defaultMenu
            ? ex.id === menuUhuuCheckedId
              ? false
              : hasSelectedExhibition(ex.id, uhuuMenus)
            : isAllRepSelected,
        repetitions: ex.repetitions.map(rep => {
          const isRepDisabled =
            !(saleType === SALE_TYPES.generalMenu) ||
            hasSelectedRepetition(rep.id, uhuuMenus, accId);
          const isAllBenefitsSelected = rep.sectors.every(sector =>
            isAllBenefitsChecked(rep.id, sector, uhuuMenus, ex.id)
          );

          switch (saleType) {
            case SALE_TYPES.defaultMenu:
              const repDisabled = ex.id === menuUhuuCheckedId ? false : true;
              return {
                ...rep,
                checked: !repDisabled ? true : false,
              };
            case SALE_TYPES.generalMenu:
              return {
                ...rep,
                disabled: isRepDisabled,
                checked: !(isAllBenefitsSelected || isAllRepSelected) && !isRepDisabled ? rep.checked : false,
              };
            default:
              return {
                ...rep,
                checked: !(isAllBenefitsSelected || isAllRepSelected) ? rep.checked : false,
                disabled: isAllBenefitsSelected || isAllRepSelected,
                sectors:
                  saleType === SALE_TYPES.specificMenu
                    ? rep.sectors.map(sec => {
                        return {
                          ...sec,
                          checked: !(
                            sec.disabled ||
                            isAllBenefitsSelected ||
                            isSectorSelected(rep.id, sec, uhuuMenus)
                          )
                            ? sec.checked
                            : false,
                          disabled:
                            sec.disabled ||
                            isAllBenefitsSelected ||
                            isSectorSelected(rep.id, sec, uhuuMenus),
                          benefits: sec.benefits.map(ben => {
                            return ben.id === UHUU_GENERAL_TICKET_TYPE
                              ? {
                                  ...ben,
                                  disabled:
                                    isFullPriceTicketSelected(uhuuMenus, rep.id, sec.id, ex.id) ||
                                    (ben.disabled ||
                                      (isAllBenefitsSelected ||
                                        isBenefitSelected(rep.id, sec.id, ben.id, uhuuMenus))),
                                }
                              : {
                                  ...ben,
                                  disabled:
                                    ben.disabled ||
                                    (isAllBenefitsSelected ||
                                      isBenefitSelected(rep.id, sec.id, ben.id, uhuuMenus)),
                                };
                          }),
                        };
                      })
                    : rep.sectors,
              };
          }
        }),
      };
    }),
  }));
};

export const isFullPriceTicketSelected = (menus, repId, sectorId, exhibitionId) => {
  return menus.some(menu =>
    menu.uhuuEvents.some(ev =>
      ev.exhibitions.some(
        ex =>
          ex.id === exhibitionId &&
          ex.repetitions.some(
            rep =>
              rep.id === repId &&
              rep.sectors.some(sec => sec.id === sectorId && sec.hasFullPriceTicketBenefit)
          )
      )
    )
  );
};

export const isBenefitSelected = (repId, secId, benefitId, menus) => {
  return menus.some(menu =>
    menu.uhuuEvents.some(ev =>
      ev.exhibitions.some(ex =>
        ex.repetitions.some(
          rep =>
            rep.id === repId &&
            rep.sectors.some(
              sec => sec.id === secId && sec.benefits.some(benefit => benefit.id === benefitId)
            )
        )
      )
    )
  );
};

export const isSectorSelected = (repId, sector, menus) => {
  return menus.some(menu =>
    menu.uhuuEvents.some(ev =>
      ev.exhibitions.some(ex =>
        ex.repetitions.some(
          rep =>
            rep.id === repId &&
            rep.sectors.some(
              sec => sec.id === sector.id && isAllBenefitsChecked(repId, sector, menus, ex.id)
            )
        )
      )
    )
  );
};

export const isAllSectorsChecked = (repId, sectors, menus) => {
  return sectors.every(sector =>
    menus.some(menu =>
      menu.uhuuEvents.some(ev =>
        ev.exhibitions.some(ex =>
          ex.repetitions.some(
            rep =>
              rep.id === repId &&
              rep.sectors.some(
                sec => sec.id === sector.id && isAllBenefitsChecked(repId, sector, menus, ex.id)
              )
          )
        )
      )
    )
  );
};

export const isAllBenefitsChecked = (repId, sector, menus, exhibitionId) => {
  let benefits = [];
  menus.some(menu =>
    menu.uhuuEvents.some(ev =>
      ev.exhibitions.some(
        ex =>
          ex.id === exhibitionId &&
          ex.repetitions.some(
            rep =>
              rep.id === repId &&
              rep.sectors.some(sec => {
                if (sec.id === sector.id) {
                  benefits = benefits.concat(...sec.benefits);
                  if (isFullPriceTicketSelected(menus, rep.id, sec.id, ex.id)) {
                    benefits = benefits.concat({ id: UHUU_GENERAL_TICKET_TYPE });
                  }
                  return true;
                }
                return false;
              })
          )
      )
    )
  );

  return sector.benefits.every(ben =>
    benefits.some(benefit =>
      ben.id === UHUU_GENERAL_TICKET_TYPE
        ? isFullPriceTicketSelected(menus, repId, sector.id, exhibitionId)
        : benefit.id === ben.id
    )
  );
};

export const hasSelectedRepetition = (repId, menus, saleType) => {
  if (!menus.length) {
    return false;
  }

  return menus.some(menu =>
    menu.uhuuEvents.some(ev =>
      ev.exhibitions.some(ex =>
        ex.repetitions.some(
          rep =>
            rep.id === repId &&
            (saleType === SALE_TYPES.generalMenu || isAllSectorsChecked(rep.id, rep.sectors, menus))
        )
      )
    )
  );
};

export const hasSelectedExhibition = (exId, menus) => {
  if (!menus.length) {
    return false;
  }

  return menus.some(menu =>
    menu.uhuuEvents.some(ev => ev.exhibitions.some(rep => rep.id === exId))
  );
};



// WEBPACK FOOTER //
// ./src/helpers/uhuu.js